import {ILangdict, Langdict} from './langdict';
import {ClassGroup, IClassGroup} from './class-group';
import {ITokenType, TokenType} from './token-type';

export class ICourseUnit {
  id: number;
  classType: { 'id': string, 'description': ILangdict };
  classGroups: IClassGroup[];
  hourCount: number;
  tokens?: ITokenType;
}

export class CourseUnit extends ICourseUnit {

  classGroups: ClassGroup[];

  constructor(obj: ICourseUnit) {
    super();
    Object.assign(this, obj);
    this.classType.description = new Langdict(obj.classType.description);
    this.classGroups = obj.classGroups.map(g => new ClassGroup(g)).sort((a, b) => a.number - b.number);
    this.tokens = obj.tokens && new TokenType(obj.tokens);
  }

  getPathFragment() {
    return [this.id];
  }
}

